const fallback = Object.freeze({
  SITE_INDEX: '',
  SITE_CODE: '',
  SITE_NAME: '',
  MASTER_SITE: false,
  RELEASE_VERSION: '',
  MASTER_RELEASE_VERSION: '',
  MASTER_ARTIFACT_SHA256: '',
  LAST_SYNC_TIME: '',
  SYNC_STATUS: 'UNINITIALIZED'
})

let current = fallback

export async function loadSiteRuntime() {
  try {
    const response = await fetch('/site-runtime.json', {cache: 'no-store', credentials: 'same-origin'})
    if (!response.ok) throw new Error(`site runtime HTTP ${response.status}`)
    const value = await response.json()
    if (!value || typeof value.SITE_CODE !== 'string' || typeof value.RELEASE_VERSION !== 'string') {
      throw new Error('invalid site runtime')
    }
    current = Object.freeze({...fallback, ...value})
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.warn(error)
  }
  return current
}

export function siteRuntime() {
  return current
}
